import { render, staticRenderFns } from "./Search_expire_product.vue?vue&type=template&id=402f0e10&"
import script from "./Search_expire_product.vue?vue&type=script&lang=js&"
export * from "./Search_expire_product.vue?vue&type=script&lang=js&"
import style0 from "./Search_expire_product.vue?vue&type=style&index=0&id=402f0e10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports